import { defineMessages } from 'react-intl';

export default defineMessages({
  createTitle: {
    id: 'sku.modifiers.editor.create-title',
    defaultMessage: 'Add modifier',
  },
  editTitle: {
    id: 'sku.modifiers.editor.edit-title',
    defaultMessage: 'Edit modifier',
  },
  editTitleNamed: {
    id: 'sku.modifiers.editor.edit-title-named',
    defaultMessage: 'Edit {groupName}',
  },
  readOnlyTitle: {
    id: 'sku.modifiers.editor.read-only-title',
    defaultMessage: 'View modifier',
  },
  detailsHeading: {
    id: 'sku.modifiers.editor.details-heading',
    defaultMessage: 'Modifier details',
  },
  nameLabel: {
    id: 'sku.modifiers.editor.name-label',
    defaultMessage: 'Modifier name',
  },
  namePlaceholder: {
    id: 'sku.modifiers.editor.name-placeholder',
    defaultMessage: 'E.g. "Condiments"',
  },
  nameRequired: {
    id: 'sku.modifiers.editor.name-required',
    defaultMessage: 'This field is required',
  },
  optionsHeading: {
    id: 'sku.modifiers.editor.options-heading',
    defaultMessage: 'Options',
  },
  optionsSubtitle: {
    id: 'sku.modifiers.editor.options-subtitle',
    defaultMessage: 'Prices should reflect the price on your menu, not including tax.',
  },
  addOption: {
    id: 'sku.modifiers.editor.add-option',
    defaultMessage: 'Add another option',
  },
  cancel: {
    id: 'sku.modifiers.editor.cancel',
    defaultMessage: 'Cancel',
  },
  close: {
    id: 'sku.modifiers.editor.close',
    defaultMessage: 'Close',
  },
  save: {
    id: 'sku.modifiers.editor.save',
    defaultMessage: 'Add modifier',
  },
  saveEdit: {
    id: 'sku.modifiers.editor.save-edit',
    defaultMessage: 'Save changes',
  },
  loadFailed: {
    id: 'sku.modifiers.editor.load-failed',
    defaultMessage: 'We could not load this modifier. Please try again.',
  },
  saveFailed: {
    id: 'sku.modifiers.editor.save-failed',
    defaultMessage: 'We could not save this modifier. Please try again.',
  },
  unsavedChanges: {
    id: 'sku.modifiers.editor.unsaved-changes',
    defaultMessage: 'You have unsaved changes. Your changes will not be saved if you navigate off this screen.',
  },
  optionDeleteBlockedTitle: {
    id: 'sku.modifiers.editor.option-delete-blocked-title',
    defaultMessage: "You can't delete this option",
  },
  optionAvailabilityBlockedTitle: {
    id: 'sku.modifiers.editor.option-availability-blocked-title',
    defaultMessage: "You can't mark this option unavailable",
  },
  optionBlockedBody: {
    id: 'sku.modifiers.editor.option-blocked-body',
    defaultMessage:
      'Your modifier rules require at least {min, plural, one {# option} other {# options}}. Lower the minimum first.',
  },
  ruleBlocked: {
    id: 'sku.modifiers.editor.rule-blocked',
    defaultMessage:
      'This modifier requires more options than are currently available. Make an option available, lower the minimum, or turn off "Make modifier selection required".',
  },
  editSharedDialogLabel: {
    id: 'sku.modifiers.editor.edit-shared-dialog-label',
    defaultMessage: 'Apply changes to all items',
  },
  editSharedTitle: {
    id: 'sku.modifiers.editor.edit-shared-title',
    defaultMessage: 'Save changes to <strong>{groupName}</strong>?',
  },
  editSharedUsedIn: {
    id: 'sku.modifiers.editor.edit-shared-used-in',
    defaultMessage:
      'This change will apply to {itemCount, plural, one {# item} other {# items}} ({itemNames}) using this modifier.',
  },
  editSharedCancel: {
    id: 'sku.modifiers.editor.edit-shared-cancel',
    defaultMessage: 'Cancel',
  },
  editSharedAction: {
    id: 'sku.modifiers.editor.edit-shared-action',
    defaultMessage: 'Save changes',
  },
});
